function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6007 22.7632C20.8028 20.8444 19.6534 18.5219 18.0938 16.3472",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6493 12.5534C13.8075 11.8432 12.8936 11.213 11.9031 10.6977C11.0247 10.2429 10.05 10.0059 9.06103 10.0066C6.48415 10.0066 4.39453 7.91765 4.39453 5.33803C4.39453 2.75965 6.48381 0.669434 9.06103 0.669434H10.3333C20.7335 0.669434 24.5165 13.9063 25.8192 21.2942M33.0607 17.6471C34.8784 10.24 38.9363 0.669434 47.7803 0.669434H49.0525C51.6297 0.669434 53.719 2.75965 53.719 5.33803C53.719 7.91607 51.631 10.0066 49.0525 10.0066C48.0635 10.0059 47.0888 10.2429 46.2105 10.6977C41.1991 13.3054 38.1306 18.868 36.5112 22.7632",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5998 54.3545C30.6124 56.3436 27.3942 56.3436 25.4062 54.3606",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1446 31.6271C44.788 33.3843 45.1227 35.2496 45.1227 37.1819C45.1227 37.8053 45.3819 38.4028 45.8529 38.8121C48.0865 40.7501 49.468 43.6453 49.3599 46.8606C49.1807 52.1662 44.8861 56.4831 39.584 56.6871C36.3205 56.8123 33.3827 55.4008 31.4354 53.1178C29.9174 51.3398 28.0851 51.3398 26.5671 53.1178C24.6199 55.4008 21.682 56.8123 18.4185 56.6871C13.1164 56.4831 8.82182 52.1662 8.64265 46.8606C8.53446 43.6475 9.91492 40.7535 12.1451 38.8155C12.6093 38.413 12.8821 37.829 12.8798 37.2157C12.8798 28.1901 20.1971 21.1127 28.8694 21.043C34.3484 20.999 39.202 23.6902 42.1477 27.8334",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1213 43.9622C17.1213 43.9622 12.0305 38.869 2.697 38.02M13.7273 47.3577C13.7273 47.3577 9.48489 43.9622 1 44.8111M16.2728 51.602C16.2728 51.602 9.48489 49.0554 3.54545 50.7532M40.879 43.9622C40.879 43.9622 45.9699 38.869 55.3034 38.02M44.273 47.3577C44.273 47.3577 48.5155 43.9622 57.0004 44.8111M41.7276 51.602C41.7276 51.602 48.5155 49.0554 54.4549 50.7532M21.9629 34.6245V35.9774M36.0375 34.6245V35.9774M29.0002 51.5585V48.3195M31.6702 45.2174C31.6702 43.5665 30.4748 43.4114 29.0002 43.4114C27.5257 43.4114 26.3303 43.5665 26.3303 45.2174C26.3303 46.8683 27.5257 48.2065 29.0002 48.2065C30.4748 48.2065 31.6702 46.8683 31.6702 45.2174Z",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgRabbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbit);
export default __webpack_public_path__ + "static/media/rabbit.b4c1535f00bc512e4e5deac903feb3cd.svg";
export { ForwardRef as ReactComponent };